import { ref, type Ref } from 'vue'

export const useAlertMessage = (): {
  hasError: Ref<boolean>
  message: Ref<string>
  addAlertMessage: (argMessage: string) => void
  deleteAlertMessage: () => void
} => {
  const hasError = ref<boolean>(false)
  const message = ref<string>('')

  /**
   * アラートメッセージを更新し、フラグ(hasError)を立てる。
   * @param argMessage エラーメッセージ
   */
  const addAlertMessage = (argMessage: string): void => {
    message.value = argMessage
    hasError.value = true
  }

  /**
   * アラート(hasError)のフラグを降ろす。
   */
  const deleteAlertMessage = (): void => {
    hasError.value = false
  }

  return {
    hasError,
    message,
    addAlertMessage,
    deleteAlertMessage
  }
}
